import React from 'react'

export default function AddInvoiceFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .form-container {
          display: flex;
          flex-direction: column;
          box-sizing: content-box;
          padding: 5px;
          height: 100%;
        }

        .form-title {
          font-size: 1rem;
          margin-bottom: 5px;
        }

        .unpaid-invoice-list-container {
          background-color: whitesmoke;
          padding: 15px;
          height: 100%;
          overflow: auto;
        }

        .unpaid-invoice-container {
          width: 100%;
          padding: 15px;
          border: solid 1px lightgrey;
          background-color: #8553F0;
          display: flex;
          font-size: 1rem;
          justify-content: space-around;
          text-align: left;
        }

        .unpaid-invoice-container:hover {
          cursor: pointer;
          color: rgba(32, 32, 32, 1);
          background-color: #8855F4;
          transform: scale(1.003);
        }

        .unpaid-invoice-item-container {
          display: flex;
          flex-direction: column;
          flex: 2;
        }
        .unpaid-invoice-item { display: flex; }
        .unpaid-invoice-item-label {
          font-weight: bold;
          flex: 1;
        }
        .unpaid-invoice-item-data { flex: 2.5; }

        .check-mark-container {
          display: flex;
          margin: auto;
          justify-content: center;
          flex: 0.5;
        }

        .check-mark {
          display: none;
          width: 20px;
          background-color: #028381;
          padding: 10px;
          border-radius: 50px;
          color: white;
          margin: auto;
          text-align: center;
        }
        .show-check-mark { display: block; }

        #loading-and-error-container {
          display: flex;
          justify-content: center
          align-items: center;
          font-size: 0.7em;
        }

        .action-buttons-container {
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
        }
      `}
      </style>
    </React.Fragment>
  )
}
